import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import Button from 'components/field/Button';
import LottiePlayer from 'components/global/LottiePlayer';
import Typography from 'components/global/Typography';

import useAccessControl from 'hooks/useAccessControl';
import useAlert from 'hooks/useAlert';
import useAppTracking from 'hooks/useAppTracking';

import axios, { setAuthorizationToken } from 'services/axios';
import { AUTH } from 'services/consts';

import { logout } from 'utils/configureStore';
import PATHS from 'utils/paths';

import { faHome } from '@fortawesome/pro-solid-svg-icons';

import * as S from './ErrorPages.styled';

const PermissionDenied = () => {
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const isHome = pathname === PATHS.BASE;
	const { showError } = useAlert();
	const dispatch = useDispatch();
	const { reset } = useAppTracking();
	const isAuthorized = useAccessControl();

	useEffect(() => {
		if (isHome) {
			if (!isAuthorized(PATHS.BASE)) {
				showError({
					header: 'unknownUserTypeOrEmptyRoleHeader',
					message: 'unknownUserTypeOrEmptyRoleMessage'
				});
				axios.post(AUTH.LOGOUT).finally(() => {
					setAuthorizationToken();
					reset();
					dispatch(logout())
						.unwrap()
						.then(() => {
							navigate(PATHS.LOGIN);
						});
				});
			}
		} else {
			navigate(PATHS.BASE, { replace: true, state: { permissionDenied: true } });
		}
	}, []);

	return isHome ? <Page /> : null;
};

const Page = () => {
	const navigate = useNavigate();

	return (
		<div>
			<S.Container>
				<LottiePlayer name="permission-denied" width="100%" height="35%" />
				<Typography variant="h2" style={{ marginBottom: 'var(--margin-2)', fontWeight: 500 }}>
					permissionDenied.header
				</Typography>
				<Typography
					style={{
						marginBottom: 'var(--margin-4)',
						width: '40rem'
					}}
					align="center"
					fontWeight={500}
					noWrap>
					permissionDenied.content
				</Typography>
				<Button icon={faHome} label="visitHomepage" onClick={() => navigate(PATHS.BASE, { replace: true })} />
			</S.Container>
		</div>
	);
};

export default PermissionDenied;
